function normalizeValue(value: any) {
  return Array.isArray(value) ? value.join(', ') : value;
}

export default function flattenGraphObject({
  entity,
  relationship,
  properties,
  id,
}: any): any {
  const newObj: any = {};
  const flattened = {
    ...entity,
    ...relationship,
    ...properties,
    _vertexID: id,
  };

  for (const [key, value] of Object.entries(flattened)) {
    newObj[key] = normalizeValue(value);
  }

  return newObj;
}
